// src/components/settings/sections/accordionStyles.js
export const getAccordionStyles = (isDark) => ({
    accordionBaseSx: {
        borderRadius: 2,
        mb: 1.5,
        border: `1px solid ${isDark ? 'rgba(148,163,184,0.3)' : 'rgba(148,163,184,0.4)'}`,
        bgcolor: isDark ? '#020617' : '#F9FAFB',
        overflow: 'hidden',
        '&:before': {
            display: 'none',
        },
    },
    summarySx: {
        bgcolor: isDark ? 'rgba(15,23,42,0.9)' : 'rgba(219,234,254,0.9)',
        minHeight: 52,
        '& .MuiAccordionSummary-content': {
            my: 0.5,
        },
        '&:hover': {
            bgcolor: isDark ? 'rgba(30,64,175,0.35)' : 'rgba(191,219,254,0.9)',
        },
        '&.Mui-expanded': {
            bgcolor: isDark ? 'rgba(30,64,175,0.45)' : 'rgba(191,219,254,1)',
        },
    },
    detailsSx: {
        bgcolor: isDark ? '#020617' : '#FFFFFF',
        borderTop: `1px solid ${isDark ? 'rgba(30,64,175,0.4)' : 'rgba(191,219,254,0.9)'}`,
        px: { xs: 2, md: 3 },
        py: 2.5,
    },
});
